import { Injectable } from '@angular/core';
import { GrpcMetadata, GrpcStatusEvent } from '@ngx-grpc/common';
import { Timestamp } from '@ngx-grpc/well-known-types';
import { AuthService } from '../../../authentication/service/auth.service';
import { catchError, map, of } from 'rxjs';
import { LoggerEndpointClient } from '../../../protos//generated/admin.pbsc';
import { LogRequest } from '../../../protos/generated/admin.pb';

@Injectable({
    providedIn: 'root'
})
export class LogsService {
    token: string = '';
    isLoading: boolean = false;
    constructor(private developerLogsService: LoggerEndpointClient, private authService: AuthService) { }

    getLogs(logRequest: LogRequest) {
        this.isLoading = true;
        this.token = localStorage.getItem('token')! || sessionStorage.getItem('token')!;
        const metadata = new GrpcMetadata();
        metadata.set('Authorization', `Bearer ${this.token}`);
      
        return this.developerLogsService.getLogs(logRequest, metadata).pipe(
          map(logResponse => {
            const logs = logResponse.logs || [];
            logs.forEach(log => {
              log.severity = this.convertSeverity(log.severity);
              if (log.timestamp) {
                log.timestampStr = this.convertToBrowserTimezone(log.timestamp);
              }
            });
      
            this.isLoading = false;
            return {
              logs,
              total: logResponse.numberOfRecords ?? logs.length
            };
          }),
          catchError((error: GrpcStatusEvent) => {
            if (error.statusCode === 16) {
              this.authService.logOut();
            }
            return of({ logs: [], total: 0 });
          })
        );
      }

    //change severity number to string
    convertSeverity(severity: number | string): string {
        switch (severity) {
            case 1:
                return 'Debug';
            case 2:
                return 'Information';
            case 3:
                return 'Warning';
            case 4:
                return 'Error';
            case 5:
                return 'Fatal';
            default:
                return 'None';
        }
    }

    convertToBrowserTimezone(timestamp: Timestamp): string {
        const date = new Date(
            Number(timestamp.seconds) * 1000 + Number(timestamp.nanos) / 1000000
        );
        const localTime = date.toLocaleString();
        return localTime;
    }
}
